import React from "react";
import { Form, Col, Button, Row } from "react-bootstrap";
import { BfButtonBlue, BfButtonBlueSecondary } from "../../../Styling/styledForm/styledBlueForm";
import {
    StyledModal,
    StyledModalBody,
    StyledModalFooter,
} from "../../../Styling/styledModal/styledModals";
import _ from 'lodash'


const LesMeldingModal = (props) => {

    const localeMessages = props.localeMessages

    const model = props.model

    const handleOk = () => {
        const resultModel = {...model}
        props.ok(resultModel)
    }

    const handleCancel = () => {
        props.close()
    }

    const messageLfCorrected = () => {
        if (model.messageText) {
            return model.messageText.replaceAll('\\r\\n', '\n')
        }
        else return ''
    } 

    return (

        <StyledModal centered show={true} onHide={handleCancel} size="xl">

            <StyledModalBody>
                <h4>{localeMessages["ML1M_Overskrift"]}</h4>
                <Form.Group>

                    <Form.Label column="sm" lg={2}>
                        {localeMessages["ML1M_sak"]}
                    </Form.Label>
                    <Col>
                        {model.caseNo} {model.debtorName}
                    </Col>
                    

                    <Form.Label column="sm" lg={2}>
                        {localeMessages["ML1M_oppgave"]}
                    </Form.Label>
                    <Col>
                        <Form.Control id="Oppgave" name="Oppgave" as="textarea" rows={8} ReadOnly style={{ backgroundColor: '#ffd7ba', whiteSpace: 'pre-line' }}
                            value={messageLfCorrected()}
                        />
                    </Col>

                </Form.Group>

            </StyledModalBody>

            <StyledModalFooter>
                {!model.isHistorical &&
                    <>
                        <BfButtonBlue onClick={handleOk}>
                            {localeMessages["ML1M_Ok"]}
                        </BfButtonBlue>
                        <BfButtonBlueSecondary textAsBorder blackBorder onClick={handleCancel}>
                            {localeMessages["ML1M_Avbryt"]}
                        </BfButtonBlueSecondary>
                    </>
                }
                {model.isHistorical &&
                    <>                       
                        <BfButtonBlue onClick={handleCancel}>
                            {localeMessages["ML1M_Lukk"]}
                        </BfButtonBlue>
                    </>
                }
                

            </StyledModalFooter>

        </StyledModal>
    );
};

export default LesMeldingModal;

